import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_SHIPPING_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * A component that renders the shipping fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl } = props;

  const shippingFeeLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );
  const shippingFeeTotals = shippingFeeLineItems
    .map(item => item?.lineTotal)
    .filter(lineTotal => lineTotal instanceof Money);
  const shippingFeeLineItem = shippingFeeLineItems[0];
  const shippingFeeTotal =
    shippingFeeTotals.length > 1 && shippingFeeTotals[0]?.currency
      ? new Money(
          shippingFeeTotals.reduce((sum, item) => sum + item.amount, 0),
          shippingFeeTotals[0].currency
        )
      : shippingFeeTotals[0] || null;
  const shippingAmount = shippingFeeTotal?.amount;
  const isFreeShipping = shippingAmount === 0;
  const hasSelectedShippingAmount =
    shippingAmount !== null && shippingAmount !== undefined && shippingAmount >= 0;

  return shippingFeeLineItem && hasSelectedShippingAmount ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={css.itemValue}>
        {isFreeShipping ? (
          <FormattedMessage id="OrderBreakdown.freeShipping" />
        ) : (
          formatMoney(intl, shippingFeeTotal)
        )}
      </span>
    </div>
  ) : null;
};

export default LineItemShippingFeeMaybe;
